module.exports = __webpack_public_path__ + "anotherhocwpaf86497935e32baa094324e08ebd98e5.png";